import { graphql } from "gatsby";
import React from "react";

interface Props {
  title: Queries.SectionTitleFragment["title"];
  category?: Queries.SectionTitleFragment["category"];
}

const SectionTitle = ({ title, category }: Props) => {
  if (category) {
    return (
      <div>
        {category && (
          <h2 className="text-xs text-gray-600 sm:text-sm">{category}</h2>
        )}
        {title && <p className="mt-2 text-2xl sm:mt-4 sm:text-4xl">{title}</p>}
      </div>
    );
  }

  return (
    title && <h2 className="mt-2 text-2xl sm:mt-4 sm:text-4xl">{title}</h2>
  );
};

export const query = graphql`
  fragment SectionTitle on DatoCmsCommonSectionTitle {
    category
    title
  }
`;

export default SectionTitle;
